'use client'

import { useTranslation } from 'react-i18next'
import { LoginForm } from '@/features/auth/ui/LoginForm'
import { AuthLayout } from './AuthLayout'

export function LoginPage() {
  const { t } = useTranslation()
  return (
    <AuthLayout
      title={t('auth.login.title')}
      description={t('auth.login.description')}
    >
      <LoginForm />
    </AuthLayout>
  )
}
